import { calculateNaiveBayesClassifier } from '../domain/naive-bayes-provider';
import { useNaiveBayesClassifierStore } from '../dal/naive-bayes-store';
import { round } from '../../../cluster/cluster-provider';

const NaiveBayesClassifierView = () => {

    const params = useNaiveBayesClassifierStore(store => store.params);
    const results = calculateNaiveBayesClassifier(params);

    return (
        <div className="grid grid-cols-[auto_auto] gap-6 items-start">
            <table>
                <thead>
                    <tr>
                        <th className="border p-4 bg-slate-100">&nbsp;</th>

                        {
                            params.titles.map((title, i) => {
                                return (
                                    <th key={ `title-${ i }` } className="border p-4 bg-slate-100">{ title }</th>
                                )
                            })
                        }

                        <th className="border p-4 bg-yellow-100">{ params.targetName }</th>
                    </tr>
                </thead>
                <tbody>
                {
                    params.rows.map((row, i) => {
                        return (
                            <tr key={ `row-${ i }` }>
                                <td className="border p-4 bg-slate-100">{ i + 1 }</td>

                                {
                                    row.map((cell, j ) => {
                                        return (
                                            <td key={ `cell-${ j }` } className="border p-4">{ cell }</td>
                                        )
                                    })
                                }

                                <td className="border p-4 bg-yellow-50">{ params.targetValues[i] }</td>
                            </tr>
                        )
                    })
                }
                </tbody>
            </table>

            <div>
                {
                    results.targets.map((target, i) => {
                        return (
                            <div key={ `target-2-${ i }` }>
                                P({ params.targetName } = { target.value } | x)
                                =
                                (

                                <span className="mx-1">
                                    <span className="text-purple-700">P(x | { params.targetName } = { target.value })</span>

                                    <span className="mx-1">*</span>

                                    <span className="text-blue-700">P({ params.targetName } = { target.value })</span>
                                </span>

                                )

                                <span className="mx-1">/</span>

                                P(x)
                            </div>
                        )
                    })
                }

                <hr className="my-4" />

                {
                    results.targets.map((target, i) => {
                        return (
                            <div key={ `target-${ i }` } className="text-blue-700">
                                P({ params.targetName } = { target.value }) = { target.count } / { params.rows.length } = { round(target.probability) }
                            </div>
                        )
                    })
                }

                <hr className="my-4" />

                <div dir="rtl">
                    אין צורך לחשב P(x) כי מספיק להשוות מונה של כל ביטוי.
                </div>

                <hr className="my-4" />

                {
                    results.targets.map((target, i) => {
                        return (
                            <div key={ `target-3-${ i }` } className="mb-4">
                                <span className="text-purple-700">P(x | { params.targetName } = { target.value })</span>
                                <span className="mx-1">=</span>

                                {
                                    params.titles.map((title, i) => {
                                        return (
                                            <span className={ i == 0 ? '' : 'ml-10' } key={ `title-3-${ i }` }>
                                                <span>
                                                    P({ title } = { params.question[i] } | { params.targetName } = { target.value } )
                                                </span>

                                                {
                                                    (i !== params.titles.length - 1) &&
                                                    <span className="mx-1">*</span>
                                                }

                                                <br/>
                                            </span>
                                        )
                                    })
                                }

                                <span className="mx-1">=</span>

                                {
                                    target.dependencies.map((dependency, i) => {
                                        return (
                                            <span key={ `dep-${ i }` }>
                                                ({ dependency.combinationCount } / { dependency.targetCount } )

                                                {
                                                    (i !== params.titles.length - 1) &&
                                                    <span className="mx-1">*</span>
                                                }

                                                <br/>
                                            </span>
                                        )
                                    })
                                }

                                <br/>
                                <span className="mx-1">=</span>

                                {
                                    target.dependencies.map((dependency, i) => {
                                        return (
                                            <span key={ `dep-${ i }` }>
                                                { round(dependency.probability) }

                                                {
                                                    (i !== params.titles.length - 1) &&
                                                    <span className="mx-1">*</span>
                                                }

                                                <br/>
                                            </span>
                                        )
                                    })
                                }

                                <span className="mx-1">=</span>
                                <span className="text-orange-700">{ round(target.dependenciesProbability) }</span>
                            </div>
                        )
                    })
                }

                <hr className="my-4" />

                {
                    results.targets.map((target, i) => {
                        return (
                            <div key={ `target-2-${ i }` } className="mb-4">
                                <span>P({ params.targetName } = { target.value } | x)</span>
                                <span className="mx-1">=</span>
                                (

                                <span className="mx-1">
                                    <span className="text-purple-700">P(x | { params.targetName } = { target.value })</span>

                                    <span className="mx-1">*</span>

                                    <span className="text-blue-700">P({ params.targetName } = { target.value })</span>
                                </span>

                                )

                                <span className="mx-1">/</span>

                                <span>P(x)</span>


                                {/* ---------------------------------- */}

                                <span className="mx-1">=</span>

                                (

                                <span className="mx-1">
                                    <span className="text-purple-700">{ round(target.dependenciesProbability) }</span>

                                    <span className="mx-1">*</span>

                                    <span className="text-blue-700">{ round(target.probability) }</span>
                                </span>

                                )

                                <span className="mx-1">/</span>

                                <span>P(x)</span>

                                {/* ---------------------------------- */}

                                <span className="mx-1">=</span>

                                (

                                <span className="mx-1 text-red-700">{ round(target.mone) }</span>

                                )

                                <span className="mx-1">/</span>

                                <span>P(x)</span>
                            </div>
                        )
                    })
                }

                <hr className="my-4" />

                <div className="text-orange-700">
                    The maximum: { round(results.maxMone) }, so &quot;{ params.targetName } = { results.maxProp }&quot; более вероятный
                </div>

                <div className="text-orange-700" dir="rtl">


                    לפי המסווג הבסיאני הנאיבי - הסיווג (חיזוי) הוא

                    <br/>

                    &quot;{ params.targetName } = { results.maxProp }&quot;
                </div>


            </div>
        </div>
    )
};

export default NaiveBayesClassifierView;